import { downloadFile, fetch, getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const linkSchoolSection = (user, sectorDocument, schoolSections) => {
  return requestWithPromise(
    `/api/sector-documents/${getIdOrNull(sectorDocument)}/school-sections`,
    HttpMethods.POST,
    { schoolSections },
    user
  )
}

export const deleteSectorDocument = (user, sectorDocument) => {
  return fetch(
    `/api/SectorDocument/${getIdOrNull(sectorDocument)}`,
    HttpMethods.DELETE,
    null,
    user
  )
}

const DEFAULT_PARAM_DOCUMENT = { id: -1, originalName: '' }
export const downloadSectorDocument = (user, document = DEFAULT_PARAM_DOCUMENT) => {
  return downloadFile(`/sector/document/download/${getIdOrNull(document)}`, document.originalName, user)
}
